import React from 'react';
import styled from 'styled-components';
import { DiscountTag } from 'src/svg/discount-tag';

type SpecialOfferRotatorProps = {
  specialNames: string[];
  hideSalesLanguage: boolean;
};

export const SpecialOfferRotator = ({ specialNames, hideSalesLanguage }: SpecialOfferRotatorProps): JSX.Element => {
  const defaultText = hideSalesLanguage ? 'Offer' : 'Special Offer';
  const displayText = specialNames[0] ?? defaultText;

  return (
    <SpecialOfferWrapper>
      <DiscountTag width={12} />
      <TextContainer>{displayText}</TextContainer>
    </SpecialOfferWrapper>
  );
};

const SpecialOfferWrapper = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.colors.green[40]};
  display: flex;
  gap: 4px;
  justify-content: var(--justify-content);
  position: relative;
  width: 100%;
`;

const TextContainer = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
